import * as marietta from '../../..';
import { Dialog } from '../../../core/view';

/**
 * 建具自動生成確認ダイアログ
 * ボタン押下で表示
 */
class ConfirmGenerateFittingsDialog2 extends Dialog {
  /**
     * コンストラクタ
     */
  constructor(draggable: boolean) {
    super(draggable);

    // ダイアログのコンテンツ生成
    const id = 'confirmGenerateFittingsDialog';
    let title = '';
    switch (marietta.webcad.WebCADGlobal.language) {
      case 'en': title = 'Automatic joinery generation'; break;
      default: title = '建具自動生成'; break;
    }

    const { currentFloor } = marietta.webcad.WebCADGlobal.webcad2Dmanager;
    let contents = '<div class="confirmGenerateFittings">\n';
    contents += `<span class="jp">${currentFloor}階の建具を全て削除し、建具の自動生成を行いますか？</span><span class="en">Would you like to delete all the fittings on ${currentFloor}F and run the auto fitting generation?</span>`;
    contents += '</div>\n';

    let footer = '<button value="true"><span class="jp">はい</span><span class="en">Yes</span></button>';
    footer += '<button><span class="jp">いいえ</span><span class="en">No</span></button>';

    this.createDialog(id, title, contents, footer);

    this.viewObj.querySelectorAll('button').forEach((element) => {
      element.addEventListener('click', this.btnEventHandler);
    });
  }

    /**
     * ボタンがクリックされた
     */
    btnEventHandler = (e) => {
      e.preventDefault();
      if ((e.currentTarget).value) {
        marietta.webcad.WebCADGlobal.cadAPIManager.generateFittings();
      }
      this.close();
    }
}
export default ConfirmGenerateFittingsDialog2;
